import HeroSection from './sections/hero/Hero.section'

export default function HomePage() {
  return (        
    <HeroSection />        
  )
}
